import { useEffect, useState } from 'react';

const useFetch = path => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const apiKey = import.meta.env.VITE_API_KEY;
        const url = `${import.meta.env.VITE_BACKEND}${path}`;
        const res = await fetch(url, {
          headers: {
            Authorization: `Bearer ${apiKey}`,
          },
        });
        const json = await res.json();

        setData(json);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, [path]);

  return { isLoading, error, data };
};

export default useFetch;
